import React, { useState, useEffect } from "react";
import { 
    Card, CardBody, Col, Container, Row, Nav, NavItem, NavLink, 
    Button, Badge, Spinner, TabContent, TabPane 
} from "reactstrap";
import classnames from "classnames";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { useNavigate } from "react-router-dom"; // Bunu eklediğinden emin ol

const Sertifikalarim = () => {
  document.title = "Sertifikalarım | HarmanaGEL";
  const navigate = useNavigate(); // Yönlendirme için tanımladık

  const authUser = JSON.parse(localStorage.getItem("authUser") || "{}");
  const userId = authUser?.ID;
  const BASE_URL = "https://harmanagelapi.stechomeyazilim.info";

  const [activeTab, setActiveTab] = useState("1");
  const [loading, setLoading] = useState(true);
  const [docs, setDocs] = useState({});

  // Kullanıcının belgelerini çek
  useEffect(() => {
    const fetchMyCertificates = async () => {
      if (!userId) return;
      setLoading(true);
      try {
        const response = await fetch(`${BASE_URL}/KULLANICILAR_Document?$filter=KULLANICI_ID eq ${userId}`);
        const result = await response.json();
        
        if (result.value && result.value.length > 0) {
            setDocs(result.value[0]);
        }
      } catch (error) {
        console.error("Sertifikalar yüklenirken hata:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchMyCertificates();
  }, [userId]);

  // Kart Bileşeni
  const CertificateCard = ({ title, icon, docUrl, isOptional }) => (
      <Col xl={3} md={4} sm={6}>
          <Card className="shadow-sm border rounded-4 h-100 text-center">
              <CardBody className="p-4 d-flex flex-column">
                  <div className="mb-3">
                      <div className={`avatar-md mx-auto`}>
                          <span className={`avatar-title rounded-circle ${docUrl ? 'bg-soft-success text-success' : 'bg-soft-secondary text-muted'} fs-2`}>
                              <i className={`mdi ${icon}`}></i>
                          </span>
                      </div>
                  </div>
                  <h6 className="fw-bold mb-1">{title}</h6>
                  
                  <div className="mt-2 mb-3">
                      {docUrl ? (
                          <Badge color="success" className="px-2 py-1"><i className="mdi mdi-check-circle me-1"></i>Sistemde Kayıtlı</Badge>
                      ) : (
                          <Badge color={isOptional ? "secondary" : "danger"} className="px-2 py-1">
                              <i className="mdi mdi-alert-circle-outline me-1"></i>{isOptional ? "İsteğe Bağlı" : "Eksik Belge"}
                          </Badge>
                      )}
                  </div>

                  <div className="mt-auto">
                      {docUrl ? (
                          <a href={docUrl} target="_blank" rel="noreferrer" className="btn btn-sm btn-outline-primary w-100 fw-bold">
                              <i className="mdi mdi-eye me-1"></i> Görüntüle
                          </a>
                      ) : (
                          <Button color="light" size="sm" className="w-100 fw-bold" disabled>
                              Belge Yok
                          </Button>
                      )}
                  </div>
              </CardBody>
          </Card>
      </Col>
  );

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="HarmanaGEL" breadcrumbItem="Sertifikalarım" />
          
         <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-2">
              <h2 className="mb-0 fw-bold">Sertifikalarım ve Belgelerim</h2>
              
              {/* onClick eklendi ve sürücü-basvurusu sayfasına yönlendirildi */}
              <Button 
                color="primary" 
                outline 
                size="sm" 
                className="fw-bold bg-white"
                onClick={() => navigate("/candidate-list")} 
              >
                  <i className="mdi mdi-cloud-upload-outline me-1"></i> Yeni Belge Yükle / Güncelle
              </Button>
          </div>

          <Row>
            <Col xs={12}>
              <Card className="shadow-sm border-0 rounded-4">
                <CardBody className="pt-3 pb-0 border-bottom bg-light bg-opacity-50 rounded-top-4">
                  <Nav tabs className="nav-tabs-custom border-bottom-0">
                    <NavItem>
                      <NavLink 
                        className={classnames({ active: activeTab === "1" }, "fw-bold cursor-pointer font-size-15 bg-transparent border-0")} 
                        onClick={() => setActiveTab("1")}
                      >
                        <i className="mdi mdi-file-document-multiple-outline me-2"></i>Resmi Evraklar
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink 
                        className={classnames({ active: activeTab === "2" }, "fw-bold cursor-pointer font-size-15 bg-transparent border-0")} 
                        onClick={() => setActiveTab("2")}
                      >
                        <i className="mdi mdi-medal-outline me-2 text-warning"></i>HarmanaGEL Başarı Rozetleri
                      </NavLink>
                    </NavItem>
                  </Nav>
                </CardBody>

                <CardBody className="p-4 p-lg-5">
                    <TabContent activeTab={activeTab}>
                        
                        {/* 1. RESMİ EVRAKLAR SEKMESİ */}
                        <TabPane tabId="1">
                            {loading ? (
                                <div className="text-center py-5">
                                    <Spinner color="primary" />
                                    <p className="mt-3 text-muted fw-medium">Belgeleriniz yükleniyor...</p>
                                </div>
                            ) : (
                                <>
                                    <p className="text-muted mb-4 font-size-15">Sisteme yüklemiş olduğunuz operasyonel ve resmi evraklarınızı buradan görüntüleyebilirsiniz.</p>
                                    <Row className="g-3">
                                        <CertificateCard title="Kimlik Belgesi" icon="mdi-card-account-details" docUrl={docs.Identity_Url} />
                                        <CertificateCard title="Sürücü Belgesi (Ehliyet)" icon="mdi-car-info" docUrl={docs.License_Url} />
                                        <CertificateCard title="Adli Sicil Kaydı" icon="mdi-scale-balance" docUrl={docs.Criminalrecord_Url} />
                                        <CertificateCard title="Vergi Levhası" icon="mdi-text-box-check-outline" docUrl={docs.Taxplate_Url} />
                                        <CertificateCard title="Çekici Sertifikası" icon="mdi-tow-truck" docUrl={docs.TowingCertificate} isOptional={true} />
                                    </Row>
                                </>
                            )}
                        </TabPane>

                        {/* 2. LOJGO BAŞARI ROZETLERİ SEKMESİ */}
                        <TabPane tabId="2">
                            <div className="text-center py-5 bg-light rounded-4 border border-dashed">
                                <i className="mdi mdi-medal text-warning display-1 mb-3 drop-shadow"></i>
                                <h4 className="fw-bold text-dark">HarmanaGEL Onaylı Sürücü Rozeti</h4>
                                <p className="text-muted w-50 mx-auto font-size-15">
                                    Tüm zorunlu evraklarınızı eksiksiz tamamladığınızda ve ilk 10 başarılı taşımanızı gerçekleştirdiğinizde bu sertifikaya hak kazanacaksınız.
                                </p>
                                <Button color="warning" className="fw-bold mt-3 px-4 shadow-sm" disabled>
                                    Henüz Kilitli
                                </Button>
                            </div>
                        </TabPane>

                    </TabContent>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Sertifikalarim;